import { QueueType } from '../models/enums/QueueType';
import { QueueTypeHandler } from './QueueTypeHandler';
import { CompositeProfileHandler } from './compositeProfile/UploadCompositeProfileHandler';
import { DefaultHandler } from './default/DefaultHandler';
import { UploadGridHandler } from './grid/UploadGridHandler';
import { UploadSeismic2DHandler } from './seismic/UploadSeismic2DHandler';
import { UploadSeismic3DHandler } from './seismic/UploadSeismic3DHandler';
import { UploadShapefileHandler } from './shapefile/UploadShapefileHandler';
import { UploadTiffHandler } from './tiff/UploadTiffHandler';

export { QueueTypeHandler };

const HANDLERS: Partial<Record<QueueType, QueueTypeHandler>> = {
    [QueueType.UploadShapefile]: new UploadShapefileHandler(),
    [QueueType.UploadSeismic2D]: new UploadSeismic2DHandler(),
    [QueueType.UploadSeismic3D]: new UploadSeismic3DHandler(),
    [QueueType.UploadTiff]: new UploadTiffHandler(),
    [QueueType.UploadGrid]: new UploadGridHandler(),
    [QueueType.CompositeProfile]: new CompositeProfileHandler(),
};

const defaultHandler: QueueTypeHandler = new DefaultHandler();

export function getQueueTypeHandler(queueType: QueueType): QueueTypeHandler {
    return HANDLERS[queueType] ?? defaultHandler;
}
